import { gql } from '@apollo/client';

const REMOVE_STUDENT_SETTING = gql`
  mutation removeStudentSettingMutation($where: StudentSettingWhereInput!) {
    removeStudentSetting(where: $where)
  }
`;

export default REMOVE_STUDENT_SETTING;
